import { ProjectCalendarFilters } from "./type";
import moment from "moment-timezone";
export const defaultFilters: ProjectCalendarFilters = {
  myZoomCall: false,
  showAvailablity: true,
  status: ["Scheduled", "Completed", "Confirmed", "Payment Requested", "Paid"],
  expert: null,
  client: null,
  date: null,
  am: null
};

export const defaultLogCall = {
  state: false,
  isChange: false,
  project_id: null,
  refetch: null,
  pe_id: null,
  expert_id: null,
  is_account_manager: false,
  is_group_admin: false,
  selected_call: null
}
export function getTimezoneLabels() {
  const timezones = moment.tz.names();
  return timezones.map((tz) => {
    const offset = moment.tz(tz).utcOffset(); // in minutes
    const offsetHours = Math.floor(offset / 60);
    const offsetMinutes = offset % 60;
    const formattedOffset = `UTC${offset >= 0 ? " +" : " -"}${String(Math.abs(offsetHours)).padStart(2, '0')}:${String(Math.abs(offsetMinutes)).padStart(2, '0')}`;
    return `${tz} (${formattedOffset})`;
  });
}


export function getTimezoneFromLabel(label:string) {
  const timezones = moment.tz.names();
  for (const tz of timezones) {
    const offset = moment.tz(tz).utcOffset();
    const offsetHours = Math.floor(offset / 60);
    const offsetMinutes = offset % 60;
    const formattedOffset = `UTC${offset >= 0 ? " +" : " -"}${String(Math.abs(offsetHours)).padStart(2, '0')}:${String(Math.abs(offsetMinutes)).padStart(2, '0')}`;
    const currentLabel = `${tz} (${formattedOffset})`;
    if (currentLabel === label) {
      return tz;
    }
  }
  return `Asia/Calcutta`;
}

export function getLabelFromTimezone(timezone: string): string {
  const offset = moment.tz(timezone).utcOffset();
  const offsetHours = Math.floor(offset / 60);
  const offsetMinutes = offset % 60;
  const formattedOffset = `UTC${offset >= 0 ? " +" : " -"}${String(Math.abs(offsetHours)).padStart(2, '0')}:${String(Math.abs(offsetMinutes)).padStart(2, '0')}`;
  return `${timezone} (${formattedOffset})`;
}
export const selectedBtnWrapper = {
  zIndex: "1001",
  position: "relative",
  backgroundColor: "white",
  borderRadius: "2px",
  "&::after": {
    content: "'Adjust the timezone here if needed. \\2715'", // Added the close icon character
    position: "absolute",
    marginLeft: "1em",
    padding: "0.5rem 1rem 0.5rem 0.5rem",
    width: "auto", // Adjust width to fit content
    backgroundColor: "var(--green-color)",
    color: "white",
    fontSize: "0.8rem",
    borderRadius: "2px",
    fontWeight: "500",
    left: "20%",
    top: "120%",
    display: "flex", // To align text and "button"
    alignItems: "center",
    justifyContent: "space-between", // Push text to left, "button" to right

  },
  "&::before": {
    content: "''",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%) scale(0.5)",
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "10px solid var(--green-color)",
    top: "100%",
  },
  "&::after::before": { // Style for the "cross" inside ::after
    content: "''",
    position: "absolute",
    top: "0.2rem",
    right: "0.2rem",
    border: "1px solid white",
    height: "0.6rem",
    width: "0.6rem",
    borderRadius: "50%",
    fontSize: "0.6rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    lineHeight: "0.6rem",
  },
  "&::after::after": { // Style for the "x" inside the circle
    content: "'\\2715'",
    position: "absolute",
    top: ".2rem",
    right: "0.2rem",
    color: "white",
    fontSize: "0.6rem",
    fontWeight: "bold",
    lineHeight: "0.6rem",
  },
};